import script from "./cooperativeEnterprise.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperativeEnterprise.vue?vue&type=script&setup=true&lang=js"

import "./cooperativeEnterprise.vue?vue&type=style&index=0&id=664b0669&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664b0669"]])

export default __exports__